import { combineReducers } from 'redux'
import ScrumBoardReducer from './ScrumBoardReducer'
import NotificationReducer from './NotificationReducer'
import EcommerceReducer from './EcommerceReducer'
import NavigationReducer from './NavigationReducer'
import OrderEditReducer from "./OrderEditReducer";
import SettingsDataOrderPullReducer from "./SettingsDataOrderPullReducer";

const RootReducer = combineReducers({
    notifications: NotificationReducer,
    settingsDataOrderPull: SettingsDataOrderPullReducer,
    navigations: NavigationReducer,
    orderDataEdit: OrderEditReducer,
    scrumboard: ScrumBoardReducer,
    ecommerce: EcommerceReducer,
})

export default RootReducer
